import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "rask-link-legend",
    templateUrl: "./link-legend.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./link-legend.component.scss"
})
export class LinkLegendComponent {
    @Input() text: string;
    @Input() url: string;
}
